<template>
    <div class="footer">
        <div>
        <!-- <p class="foot-copyright">版权所有：五洲汉风网络科技（北京）有限公司</p> -->
        <p class="foot-copyright">备案许可：<a href="javascript:;"><img src="../img/footer/ba.png?v=2.2.7">京ICP备13044591号-6</a></p></div>
        <div>
            网络视听许可证：0109385号  京ICP证140531号
        </div>
    </div>
</template>

<script>
export default {
    name: 'm_page',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
    width: 100%;
    height: 2.3rem;
    background-color: #364347;
    color: #0064ba;
    text-align: center;
    font-size: 0.12rem;
    color: #fff;
    line-height: 0.3rem;
    box-sizing: border-box;
    padding-top: 0.5rem;
    padding-bottom: 0.6rem;
    p {
        margin: 0.1rem auto;
    }
    a {
        text-decoration: none;
        color: #fff;
        img {
            width: 0.25rem;
        }
    }
}
</style>
